/** For styling */
export const FLIGHT_OVERVIEW_NAME = 'fightsOverview';
export const FLIGHT_OVERVIEW_SIZE = 490;
